import React, { useState } from 'react';

const Support = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    category: 'general'
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the form data to your backend
    alert('ጥያቄዎ ተልኳል! በቅርቡ መልስ እንሰጣለን።');
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: '',
      category: 'general'
    });
  };

  return (
    <div className="page-container support-theme">
      {/* Enhanced Page Header */}
      <div className="page-header">
        <h1 className="page-main-title">
          🤝 ማጠናከሪያ
        </h1>
        <div className="page-subtitle">
          Support - ድጋፍ እና ማጠናከሪያ አገልግሎት
        </div>
        <div className="page-description">
          <p className="page-description-main">
            ለማንኛውም ጥያቄ፣ ችግር ወይም ሐሳብ እዚህ ያግኙን
          </p>
          <p className="page-description-sub">
            Contact us for any questions, issues, or suggestions
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
        {/* Contact Form */}
        <div className="content-container">
          <div className="content-header">
            <div className="content-icon">📝</div>
            <h2 className="content-title">ጥያቄ ይላኩ</h2>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="control-group">
              <label htmlFor="name" className="control-label">
                👤 ስም *
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="የእርስዎ ሙሉ ስም"
                className="control-input"
                required
              />
            </div>

            <div className="control-group">
              <label htmlFor="email" className="control-label">
                📧 ኢሜይል *
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="example@email.com"
                className="control-input"
                required
              />
            </div>

            <div className="control-group">
              <label htmlFor="category" className="control-label">
                🏷️ የጥያቄ አይነት
              </label>
              <select
                id="category"
                name="category"
                value={formData.category}
                onChange={handleInputChange}
                className="control-select"
              >
                <option value="general">አጠቃላይ ጥያቄ</option>
                <option value="technical">ቴክኒካል ችግር</option>
                <option value="content">የይዘት ጥያቄ</option>
                <option value="suggestion">ሐሳብ</option>
                <option value="prayer">የጸሎት ጥያቄ</option>
                <option value="feedback">ግብረመልስ</option>
              </select>
            </div>

            <div className="control-group">
              <label htmlFor="subject" className="control-label">
                📋 ርዕስ *
              </label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleInputChange}
                placeholder="የጥያቄዎ ርዕስ"
                className="control-input"
                required
              />
            </div>

            <div className="control-group">
              <label htmlFor="message" className="control-label">
                💬 መልዕክት *
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                placeholder="የጥያቄዎን ወይም መልዕክትዎን በዝርዝር ይጻፉ..."
                rows="6"
                className="control-input resize-none"
                required
              />
            </div>

            <button type="submit" className="btn-primary w-full">
              <span>📤</span>
              ጥያቄ ላክ
            </button>
          </form>
        </div>

        {/* Support Information */}
        <div className="space-y-6">
          {/* Contact Information */}
          <div className="content-container">
            <div className="content-header">
              <div className="content-icon">📞</div>
              <h2 className="content-title">የመገናኛ መረጃ</h2>
            </div>
            
            <div className="space-y-4">
              <div className="flex items-center gap-3 p-3 bg-blue-50 rounded-lg">
                <span className="text-2xl">📧</span>
                <div>
                  <p className="font-semibold text-gray-800">ኢሜይል</p>
                  <p className="text-gray-600">hailemariameyayu2012@gmail.com</p>
                </div>
              </div>

              <div className="flex items-center gap-3 p-3 bg-green-50 rounded-lg">
                <span className="text-2xl">📱</span>
                <div>
                  <p className="font-semibold text-gray-800">ስልክ</p>
                  <p className="text-gray-600">+251-938169557</p>
                </div>
              </div>

              <div className="flex items-center gap-3 p-3 bg-purple-50 rounded-lg">
                <span className="text-2xl">📍</span>
                <div>
                  <p className="font-semibold text-gray-800">አድራሻ</p>
                  <p className="text-gray-600">አዲስ አበባ, ኢትዮጵያ</p>
                </div>
              </div>

              <div className="flex items-center gap-3 p-3 bg-orange-50 rounded-lg">
                <span className="text-2xl">⏰</span>
                <div>
                  <p className="font-semibold text-gray-800">የመልስ ጊዜ</p>
                  <p className="text-gray-600">በ24-48 ሰዓት ውስጥ</p>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="content-container">
            <div className="content-header">
              <div className="content-icon">❓</div>
              <h2 className="content-title">ተደጋጋሚ ጥያቄዎች</h2>
            </div>
            
            <div className="space-y-3">
              <details className="bg-gray-50 rounded-lg p-4">
                <summary className="font-semibold text-gray-800 cursor-pointer">
                  እንዴት አገልግሎቱን መጠቀም እችላለሁ?
                </summary>
                <p className="mt-2 text-gray-600 text-sm">
                  አገልግሎቱ ነጻ ነው። በላይኛው ሜኑ ላይ ያሉትን አገናኞች በመጠቀም የተለያዩ ክፍሎችን መጎብኘት ይችላሉ።
                </p>
              </details>

              <details className="bg-gray-50 rounded-lg p-4">
                <summary className="font-semibold text-gray-800 cursor-pointer">
                  የቴክኒካል ችግር ካጋጠመኝ ምን ላድርግ?
                </summary>
                <p className="mt-2 text-gray-600 text-sm">
                  የቴክኒካል ችግር ካጋጠመዎ ከላይ ባለው ፎርም በመጠቀም ወይም በቀጥታ በኢሜይል ያግኙን።
                </p>
              </details>

              <details className="bg-gray-50 rounded-lg p-4">
                <summary className="font-semibold text-gray-800 cursor-pointer">
                  አዲስ ይዘት መጨመር ይቻላል?
                </summary>
                <p className="mt-2 text-gray-600 text-sm">
                  አዎ! የኢትዮጵያ ኦርቶዶክስ ተዋሕዶ ቤተ ክርስቲያን ትምህርቶች ጋር የተያያዘ ይዘት ለመጨመር ሐሳብ ማቅረብ ይችላሉ።
                </p>
              </details>

              <details className="bg-gray-50 rounded-lg p-4">
                <summary className="font-semibold text-gray-800 cursor-pointer">
                  በሞባይል ስልክ መጠቀም ይቻላል?
                </summary>
                <p className="mt-2 text-gray-600 text-sm">
                  አዎ! ድረ-ገጹ በሞባይል ስልክ፣ ታብሌት እና ኮምፒውተር ላይ በደንብ ይሰራል።
                </p>
              </details>
            </div>
          </div>

          {/* Prayer Request */}
          <div className="content-container bg-gradient-to-br from-yellow-50 to-orange-50">
            <div className="content-header">
              <div className="content-icon bg-yellow-100 text-yellow-600">🙏</div>
              <h2 className="content-title text-yellow-800">የጸሎት ጥያቄ</h2>
            </div>
            
            <div className="text-center">
              <p className="text-yellow-700 mb-4">
                በጸሎት አስቡኝ! ገብረ ጊዮርጊስ
              </p>
              <p className="text-sm text-yellow-600 mb-4">
                "ተዘከረነ እግዚኦ በውስተ መንግሥትከ"
              </p>
              <button className="btn-warning">
                <span>🙏</span>
                በጸሎት አስባለሁ
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;